var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.903,
    height: 16.741,
    viewBox: "0 0 27.903 16.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12562",
    "data-name": "Group 12562",
    transform: "translate(-81.416 -966.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37754",
    "data-name": "Path 37754",
    d: "M13.951,115.371A8.371,8.371,0,0,0,8.371,100.8a8.349,8.349,0,1,0,0,16.7,8.106,8.106,0,0,0,5.58-2.126Z",
    transform: "translate(81.416 865.207)",
    fill: "#07a9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37755",
    "data-name": "Path 37755",
    d: "M0,109.171A8.355,8.355,0,0,0,8.371,117.5a8.063,8.063,0,0,0,5.58-2.17h0A8.349,8.349,0,0,0,8.371,100.8",
    transform: "translate(81.416 865.207)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37756",
    "data-name": "Path 37756",
    d: "M76.675,102.97a8.354,8.354,0,0,0-5.58-2.17h-.4a10.291,10.291,0,0,0-.044,16.7h.4a8.063,8.063,0,0,0,5.58-2.17,8.369,8.369,0,0,0,.044-12.357Z",
    transform: "translate(18.691 865.207)",
    fill: "#0284cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37757",
    "data-name": "Path 37757",
    d: "M213.794,100.8a8.254,8.254,0,0,0-5.625,2.17,7.959,7.959,0,0,0-.841.886h1.683a6.329,6.329,0,0,1,.62.886h-2.967a8.782,8.782,0,0,0-.487.886h3.942a7.388,7.388,0,0,1,.354.886h-4.606c-.089.31-.177.576-.266.886h5.138a7.759,7.759,0,0,1,.177,1.772,7.611,7.611,0,0,1-.443,2.657h-4.606a7.381,7.381,0,0,0,.354.886h3.942a5.674,5.674,0,0,1-.487.886h-2.967a6.33,6.33,0,0,0,.62.886h1.683a7.959,7.959,0,0,1-.842.886,8.468,8.468,0,0,0,5.625,2.17,8.371,8.371,0,0,0,0-16.741Z",
    transform: "translate(-112.801 865.207)",
    fill: "#ff2957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37758",
    "data-name": "Path 37758",
    d: "M213.794,100.8h0a8.254,8.254,0,0,0-5.625,2.17,7.959,7.959,0,0,0-.841.886h1.683a6.329,6.329,0,0,1,.62.886h-2.967a8.782,8.782,0,0,0-.487.886h3.942a7.388,7.388,0,0,1,.354.886h-4.606c-.089.31-.177.576-.266.886h5.138a7.759,7.759,0,0,1,.177,1.772,7.611,7.611,0,0,1-.443,2.657h-4.606a7.381,7.381,0,0,0,.354.886h3.942a5.674,5.674,0,0,1-.487.886h-2.967a6.33,6.33,0,0,0,.62.886h1.683a7.959,7.959,0,0,1-.842.886,8.468,8.468,0,0,0,5.625,2.17,8.317,8.317,0,0,0,8.326-8.326",
    transform: "translate(-112.801 865.207)",
    fill: "#ed1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37759",
    "data-name": "Path 37759",
    d: "M252,152.4a8.374,8.374,0,0,0,0-12.4v12.4Z",
    transform: "translate(-156.633 828.176)",
    fill: "#0466b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37760",
    "data-name": "Path 37760",
    d: "M452,280.266a.266.266,0,1,1,.266.266.286.286,0,0,1-.266-.266Zm.266.221c.133,0,.177-.089.177-.221a.162.162,0,0,0-.177-.177.2.2,0,0,0-.221.177.284.284,0,0,0,.221.221Zm0-.133h-.044v-.221h.133l.044.044c0,.044,0,.044-.044.044l.044.089h-.044l-.044-.089h-.044v.133Zm0-.133h.044v-.044h-.044v.044Z",
    transform: "translate(-345.561 695.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37761",
    "data-name": "Path 37761",
    d: "M208.169,104.373a7.958,7.958,0,0,0-.841.886h1.683a6.33,6.33,0,0,1,.62.886h-2.967a8.782,8.782,0,0,0-.487.886h3.942a7.388,7.388,0,0,1,.354.886h-4.606c-.089.31-.177.576-.266.886h5.138a7.759,7.759,0,0,1,.177,1.772,7.611,7.611,0,0,1-.443,2.657h-4.606a7.381,7.381,0,0,0,.354.886h3.942a5.674,5.674,0,0,1-.487.886h-2.967a6.33,6.33,0,0,0,.62.886h1.683a7.958,7.958,0,0,1-.842.886,8.468,8.468,0,0,0,5.625,2.17h.4a10.279,10.279,0,0,0,0-16.653h-.4A7.978,7.978,0,0,0,208.169,104.373Z",
    transform: "translate(-112.801 863.803)",
    fill: "#d1094b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37762",
    "data-name": "Path 37762",
    d: "M54.918,217.052H53.855l.62-3.233-1.417,3.233h-.93l-.177-3.233-.62,3.233H50.4l.8-4.252h1.639l.089,2.657,1.152-2.657h1.683Z",
    transform: "translate(33.807 759.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37763",
    "data-name": "Path 37763",
    d: "M112.844,215.947l.62-1.373-.487,2.569a4.148,4.148,0,0,0,.177.709h.709l.8-4.252h-1.55a8.556,8.556,0,0,0-.31,2.17C112.844,215.814,112.844,215.859,112.844,215.947Z",
    transform: "translate(-25.139 758.651)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37764",
    "data-name": "Path 37764",
    d: "M315.15,217.763a2.457,2.457,0,0,1-.753.133c-.531,0-.8-.266-.8-.753a.865.865,0,0,1,.044-.31l.044-.354.044-.266.487-2.613h1.019l-.133.8h.531l-.133.8h-.531l-.266,1.417a.446.446,0,0,1-.044.133c0,.177.133.266.354.266.133,0,.221,0,.266-.044l-.133.8Z",
    transform: "translate(-214.822 758.651)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37765",
    "data-name": "Path 37765",
    d: "M350.7,226.489c-.089-.044-.089-.044-.133-.044s-.089,0-.089-.044h-.133c-.354,0-.576.133-.886.576l.089-.531h-.93L348,229.9h1.063c.354-2.126.531-2.48,1.019-2.48h.133l.133.044.354-.974Z",
    transform: "translate(-247.316 746.559)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37766",
    "data-name": "Path 37766",
    d: "M260.4,227.552q0,.664.8.93c.443.177.487.221.487.4,0,.221-.177.31-.62.31a3.372,3.372,0,0,1-.93-.133l-.133.8h.044l.177.044h.266a3.178,3.178,0,0,0,.576.044c1.107,0,1.639-.354,1.639-1.152,0-.487-.221-.753-.753-.974-.443-.177-.487-.221-.487-.354q0-.266.531-.266a4.829,4.829,0,0,1,.753.044l.133-.8a6.543,6.543,0,0,0-.93-.044c-1.152,0-1.55.531-1.55,1.152Z",
    transform: "translate(-164.189 746.559)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37767",
    "data-name": "Path 37767",
    d: "M143.679,229.143h-.842v-.354a1.474,1.474,0,0,1-1.107.4.883.883,0,0,1-.93-.93c0-.842.664-1.329,1.816-1.329h.443a.593.593,0,0,0,.044-.221c0-.221-.177-.31-.664-.31a4.461,4.461,0,0,0-.841.089l-.133.044h-.089l.133-.753a4.624,4.624,0,0,1,1.24-.177c.886,0,1.373.354,1.373,1.019a2.661,2.661,0,0,1-.089.709l-.221,1.24-.044.221-.044.177v.133l-.044.044Zm-.753-1.55H142.7c-.576,0-.886.177-.886.531a.326.326,0,0,0,.354.354.786.786,0,0,0,.753-.886Z",
    transform: "translate(-51.59 747.315)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37768",
    "data-name": "Path 37768",
    d: "M206.035,229.055a4.369,4.369,0,0,1-1.063.133c-1.152,0-1.772-.531-1.772-1.55a1.857,1.857,0,0,1,1.816-2.037,1.225,1.225,0,0,1,1.373,1.24,3.272,3.272,0,0,1-.133.841h-2.082v.133c0,.4.31.62.886.62a2.188,2.188,0,0,0,1.063-.221l-.089.842Zm-.531-2.037v-.177a.432.432,0,0,0-.487-.443.7.7,0,0,0-.664.62Z",
    transform: "translate(-110.535 747.315)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37769",
    "data-name": "Path 37769",
    d: "M392.476,227.593a1.841,1.841,0,0,1-2.037,1.639,1.478,1.478,0,0,1-1.639-1.594,1.929,1.929,0,0,1,2.037-2.037,1.512,1.512,0,0,1,1.639,1.55v.443Zm-1.107-.443c0-.354-.133-.664-.576-.664-.531,0-.841.62-.841,1.2,0,.443.221.753.576.753a1.027,1.027,0,0,0,.8-.842,1.662,1.662,0,0,0,.044-.443Z",
    transform: "translate(-285.859 747.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37770",
    "data-name": "Path 37770",
    d: "M389.033,251.463a7.244,7.244,0,0,0,.089-.974V250.4a3.443,3.443,0,0,0-.089.709A.485.485,0,0,0,389.033,251.463Z",
    transform: "translate(-286.049 723.888)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.d5211347.svg";
export { ForwardRef as ReactComponent };